import { render, staticRenderFns } from "./HandlerForm.vue?vue&type=template&id=2d46de9c&scoped=true"
import script from "./HandlerForm.vue?vue&type=script&lang=js"
export * from "./HandlerForm.vue?vue&type=script&lang=js"
import style0 from "./HandlerForm.vue?vue&type=style&index=0&id=2d46de9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d46de9c",
  null
  
)

export default component.exports